import watergate from "@/api/water-gate";

export default {
    state: {
        waterGates: [],
        waterSupplyGates: [],
        waterOutGates: [],
    },

    mutations: {
        ["RETRIEVE_WATER_GATES"](state, data) {
            state.waterGates = data;
        },
        ["RETRIEVE_WATER_SUPPLY_GATES"](state, data) {
            state.waterSupplyGates = data;
        },
        ["RETRIEVE_WATER_OUT_GATES"](state, data) {
            state.waterOutGates = data;
        },
    },

    actions: {
        async retrieveWaterGateLogs(context, { count, lastId = null, skip = 0 }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    count: count,
                };
                if (lastId) {
                    params.latest_log_id = lastId;
                }
                if (skip > 0) {
                    params.skip_page = skip;
                }
                let res = await watergate.indexLogs(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
        async retrieveWaterGateAllLogs(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                };
                let res = await watergate.indexLogs(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },        async retrieveWaterGates(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                };
                let res = await watergate.index(params);
                context.commit("RETRIEVE_WATER_GATES", res.data.data['water_gate_list']);
                context.commit("RETRIEVE_WATER_SUPPLY_GATES", res.data.data['supply_list']);
                context.commit("RETRIEVE_WATER_OUT_GATES", res.data.data['out_list']);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
        async insertWaterSupplyGate(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                params.user_id = await context.dispatch("showUserId");
                await watergate.insertWaterSupply(params);
            } catch (error) {
                console.log(error);
            }
        },
        async insertWaterOutGate(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                params.user_id = await context.dispatch("showUserId");
                await watergate.insertWaterOut(params);
            } catch (error) {
                console.log(error);
            }
        },
        async insertWaterSupplyGates(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                params.user_id = await context.dispatch("showUserId");
                await watergate.insertWaterSupplyGates(params);
            } catch (error) {
                console.log(error);
            }
        },
        async insertWaterOutGates(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                params.user_id = await context.dispatch("showUserId");
                await watergate.insertWaterOutGates(params);
            } catch (error) {
                console.log(error);
            }
        },
    },

    getters: {
        getWaterGates(state) {
            return state.waterGates;
        },
        getWaterSupplyGates(state) {
            return state.waterSupplyGates;
        },
        getWaterOutGates(state) {
            return state.waterOutGates;
        },
    },
};
